import { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { NotificationsContext, Notification } from "./context";

export const NotificationsProvider = ({ children }: PropsWithChildren) => {
  const [notifications, setNotificationsState] = useState<Notification[]>([]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.read).length,
    [notifications],
  );

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  const setNotifications = useCallback((data: Notification[]) => {
    setNotificationsState(data);
  }, []);

  const markAsRead = useCallback((id: string) => {
    setNotificationsState((prev) =>
      prev.map((notification) =>
        notification.id === id ? { ...notification, read: true } : notification,
      ),
    );
  }, []);

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        unreadCount,
        isDrawerOpen,
        openDrawer,
        closeDrawer,
        setNotifications,
        markAsRead,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};
